import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formattedCurrency',
})
export class FormattedCurrencyPipe implements PipeTransform {
  constructor() {}

  transform(value: string | number): any {
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(numericValue)) {
      return value;
    }

    const formattedValue = numericValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return formattedValue;
  }
}
